<template>
  <v-app>
    <v-main>
      <kpi-summary-search/>
      <div class="mx-auto w-75">
        <kpi-summary-chart :height="200" :labels="labels" :datasets="datasets"/>
      </div>
    </v-main>
  </v-app>
</template>


<script>
import KPISummarySearch from "../components/analytics/KPISummarySearch.vue";
import KPISummaryChart from "../components/analytics/KPISummaryChart.vue";

export default {
  name: "analytics",
  components: {
    "kpi-summary-search": KPISummarySearch,
    "kpi-summary-chart": KPISummaryChart,
    },
  data() {
    return {
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      datasets: [
        {
          borderColor: '#249EBF',
          pointBackgroundColor: 'white',
          borderWidth: 1,
          pointBorderColor: '#249EBF',
          backgroundColor: 'transparent',
          label: 'Data',
          data: [40, 20, 12, 39, 10, 40, 39, 80, 40, 20, 21, 44]
        },
        {
          label: 'Data',
          backgroundColor: 'blue',
          data: [22, 40, 44, 55, 10, 43, 76, 12, 34, 22, 12, 11]
        },
        {
          label: 'Data',
          backgroundColor: 'black',
          data: [10, 54, 33, 33, 12, 23, 11, 65, 23, 20, 12, 11]
        },
      ]
    }
  }
};
</script>